class Utils {

    static HEADER = document.querySelector('.header');
    static NAV_LINKS = document.querySelectorAll('.header .navigation li');

    static MOB_NAV_LINKS = document.querySelectorAll('.mobile_menu .navigation li');


    static MAIN_PAGES_CONTAINER = document.querySelector('.main-pages');
    static SUB_PAGES = document.querySelectorAll('.main-pages .sub-page');

    static IS_MENU_OPEN = false;

    static IS_MOBILE_VIEW = window.innerWidth <= 992;
    static IS_DESKTOP_VIEW = window.innerWidth > 992;
    static WINDOW_HEIGHT = window.innerHeight;

    static SHORT_COUNTRY_NAMES = {
        "United States": "USA",
        "United Kingdom": "UK",
        "United Arab Emirates": "UAE",
        "Hong Kong SAR, China": "Hong Kong",
        "Iran, Islamic Rep.": "Iran",
        "Russian Federation": "Russia",
    }

    // Fade out element with opacity transition
    static fadeOut(el, duration = 1) {
        let opacity = 1;

        const timer = setInterval(() => {
            if (opacity <= 0) {
                clearInterval(timer);
                el.style.visibility = 'hidden'; // Hide element after fading out
            }

            el.style.opacity = opacity;
            opacity -= 0.1;
        }, duration);
    }

    // Fade in element with opacity transition
    static fadeIn(el, duration = 1) {
        let opacity = 0;
        el.style.visibility = 'visible'; // Make element visible at the start

        const timer = setInterval(() => {
            if (opacity >= 1) {
                clearInterval(timer);
            }

            el.style.opacity = opacity;
            opacity += 0.1;
        }, duration);
    }

    static transformElem(elem, x, y) {
        elem.style.transform = `translate(${x}, ${y})`
    }

    static toTitleCase(str) {
        return str.replace(
            /\w\S*/g,
            text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
        );
    }

    static getSegmentWiseAverage(data) {
        const groupedData = [
            { label: "Life Expectancy", value: data.Life_expectancy, group: "Human" },
            { label: "Suicide", value: data.Suicide_mortality, group: "Human" },
            { label: "Tertiary Education", value: data.Percent_of_population, group: "Human" },
            { label: "Age Dependency", value: data.Age_dependency_ratio, group: "Human" },
            { label: "Human Capital", value: data.Human_capital, group: "Human" },
            { label: "Physical Capital", value: data.Physical_capital, group: "Physical" },
            { label: "Internet Usage", value: data.Individuals_using_internet, group: "Physical" },
            { label: "Logistics", value: data.World_Bank_logistics, group: "Physical" },
            { label: "Secure Internet", value: data.Secure_internet, group: "Physical" },
            { label: "Electricity Access", value: data.Access_to_electricity, group: "Physical" },
            { label: "Social Trust", value: data.Trust, group: "Social" },
            { label: "Natural Capital", value: data.Natural_capital, group: "Natural" },
            { label: "Pollution", value: data.PM2_5, group: "Natural" },
            { label: "Water Stress", value: data.Water_stress, group: "Natural" },
            { label: "Patents", value: data.Patent_applications, group: "Innovation" },
            { label: "Science Journals", value: data.Science_journal, group: "Innovation" },
            { label: "Sector Concentration", value: data.Hirschman_Index, group: "Innovation" },
            { label: "Institutional Quality", value: data.World_Bank_institutional, group: "Institution" },
            { label: "Inequality", value: data.Inequality_principal, group: "Institution" },
        ];

        const groupAverages = groupedData.reduce((acc, item) => {
            // Initialize the group if not present
            if (!acc[item.group]) {
                acc[item.group] = { total: 0, count: 0 };
            }
            // Add the item's value to the total and increment the count
            acc[item.group].total += item.value;
            acc[item.group].count += 1;

            return acc;
        }, {});

        // Format the result as an array with group names and their averages
        const averages = Object.entries(groupAverages).map(([label, { total, count }]) => ({
            label,
            value: total / count
        }));

        return averages
    }

    static truncateToDecimals(num, decimals) {
        let multiplier = Math.pow(10, decimals);
        return Math.floor(num * multiplier) / multiplier;
    }

    static roundUpToDecimal(value, decimals) {
        return value.toFixed(decimals)
    }

    static extractDecimalDigit(value, decimals) {
        let decimalPart = value - Math.floor(value);
        return Math.round(decimalPart * Math.pow(10, decimals));
    }

    static calculatePercentageDifference(a, b) {
        const difference = Math.abs(a - b);  // Get the absolute difference between a and b
        const average = (a + b) / 2;         // Calculate the average of a and b
        const percentageDifference = (difference / average) * 100;  // Calculate the percentage difference
        return percentageDifference;
    }

    static modifyText(inputText) {
        // Remove periods and commas, then replace spaces with hyphens
        let modifiedText = inputText.replace(/[.,]/g, '').replace(/\s+/g, '-');
        return modifiedText;
    }

    static getIndexByDataPage(dataPage) {
        const listItems = window.innerWidth <= 992 ? Utils.MOB_NAV_LINKS : Utils.NAV_LINKS // Select all li elements
        for (let i = 0; i < listItems.length; i++) {
            if (listItems[i].dataset.page === dataPage) {
                return i; // Return the index of the matching li element
            }
        }
        return -1; // Return -1 if no match is found
    }
}

export default Utils;
